const Seo = {
    defaultTitleSeo: 'InstaSorteio - Dibujar con comentarios de Instagram',
    defaultDescriptionSeo: 'Realice sorteos a partir de los comentarios de Instagram. El único que puede cargar todos los comentarios.',
    defaultKeywordsSeo: 'sorteos, rifas, instagram, realizar, insta',
    defaultImageSeo: 'https://instasorteio.com/images/seo/metatag-es.png',
  };
  
  export default Seo;
  